import { Model } from '@vuex-orm/core';
import Availability from '@/models/Availability';
import Sectionable from '@/models/Sectionable';
import Illustration from '@/models/Illustration';
import Image from '@/models/Image';
import Imageable from '@/models/Imageable';
import Shape from '@/models/Shape';
import Residence from '@/models/Residence';
import Selector from '@/models/Selector';

export default class Section extends Model {
  static entity = 'sections';

  static state() {
    return {
      selectedSection: 'all',
    };
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),
      url: this.attr(null),

      isSelected: this.boolean(false),
      singleImg: this.boolean(true),
      activeIllustrationId: this.attr(null),

      // Relationships
      availability_id: this.attr(null),
      availability: this.belongsTo(Availability, 'availability_id'),
      illustrations: this.morphedByMany(
        Illustration,
        Sectionable,
        'section_id',
        'sectionable_id',
        'sectionable_type'
      ),
      images: this.morphToMany(
        Image,
        Imageable,
        'image_id',
        'imageable_id',
        'imageable_type'
      ),
      shapes: this.morphMany(Shape, 'shapeable_id', 'shapeable_type'),
      residences: this.morphedByMany(
        Residence,
        Sectionable,
        'section_id',
        'sectionable_id',
        'sectionable_type'
      ),
      selector_id: this.attr(null),
      selector: this.belongsTo(Selector, 'selector_id'),
    };
  }

  static transformer(data) {
    const sections = [];
    data.data.forEach(item => {
      const section = {};
      section.id = item.id;
      section.name = item.name;
      section.slug = item.slug;
      section.count = item.count;
      section.description = item.description;
      sections.push(section);
    });
    return sections;
  }

  static apiConfig = {
    dataTransformer: data => this.transformer(data),
  };

  static fetch(baseURL) {
    // TODO: Add paginated fetch.
    let url = '/wp-json/wp/v2/section?per_page=100';
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}
